export default "__VITE_ASSET__CV6Gmz2t__";